
export const environment = {
  production: false,
  baseUrl: 'https://api.dev.medintia.com/graphql',
  apiUrl: 'https://api.dev.medintia.com/api',
  fileUrls: 'https://h8e2otfnf0.execute-api.us-east-1.amazonaws.com/demo/files',
  apiKey: 'bvzZ0qa3Et50PK5cx7UH55M9cPzA7ZAO9Se0iLyP',
  attentionAttachment: 'https://api.dev.medintia.com/api/media/upload',
  medicalChatbot: 'https://h8e2otfnf0.execute-api.us-east-1.amazonaws.com/demo/medical_assistant',
  billingApiUrl: 'https://billing-api.dev.medintia.com/api/v1',
  billingApiKey: 'ciNoNY4XWfeGgWqsYEvhOf9B2dLd2y3JKMz2seiPL71c1BLVl1mCG5Z5FsaGoGQWOtmUbtcfOjYkK5pw',
  fevDefaults: {
    softwareId: '',
    testSetId: '',
    countryId: 46,
    taxId: 1,
    merchantRegistration: ''
  }


};
